import { render, staticRenderFns } from "./TeamSelection.vue?vue&type=template&id=2bc41114&scoped=true"
import script from "./TeamSelection.vue?vue&type=script&lang=js"
export * from "./TeamSelection.vue?vue&type=script&lang=js"
import style0 from "./TeamSelection.vue?vue&type=style&index=0&id=2bc41114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc41114",
  null
  
)

export default component.exports